import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import VoucherClaimContainer from "../containers/VoucherClaimContainer";

const VoucherClaimPage = () => {
  return (
    <UnderMaintenanceOrChildren>
      <VoucherClaimContainer />
    </UnderMaintenanceOrChildren>
  );
};

export default VoucherClaimPage;
